// extracted by mini-css-extract-plugin
module.exports = {"icon":"TAIconBar_icon__1Vejs"};